import { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { AuthContext } from './authContext'

export default function AuthProvider({ children }) {
  const [session, setSession] = useState(null)
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()
  const location = useLocation()
  const locationRef = useRef(location)

  useEffect(() => {
    locationRef.current = location
  }, [location])

  useEffect(() => {
    /* Grab the current session on mount */
    supabase.auth.getSession().then(({ data: { session: current } }) => {
      setSession(current)
      setLoading(false)
    })

    /* Listen for auth state changes (sign-in, sign-out, token refresh, expiry) */
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event, nextSession) => {
      setSession(nextSession)

      /* Redirect to login when user signs out or session expires (not on initial load) */
      if (!nextSession && event !== 'INITIAL_SESSION') {
        const loc = locationRef.current
        const pathname = loc?.pathname && loc.pathname !== '/login' ? loc.pathname : '/dashboard'
        navigate('/login', { state: { from: { pathname } }, replace: true })
      }
    })

    return () => subscription.unsubscribe()
  }, [navigate])

  const value = {
    session,
    user: session?.user ?? null,
    isAuthed: Boolean(session),
    loading,
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
